module.exports = __webpack_public_path__ + "static/img/minus.5a379c46.png";